const CrossedIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14.849}
    height={14.849}
    {...props}
  >
    <g fill="none" stroke="#000" strokeLinecap="round" strokeWidth={2}>
      <path d="m13.435 1.414-12.02 12.02" data-name="Line 136" />
      <path d="m1.414 1.414 12.021 12.021" data-name="Line 137" />
    </g>
  </svg>
);
export default CrossedIcon;
